import { render, staticRenderFns } from "./page-referral-tracking.vue?vue&type=template&id=33c444ef"
import script from "./page-referral-tracking.vue?vue&type=script&lang=ts"
export * from "./page-referral-tracking.vue?vue&type=script&lang=ts"
import style0 from "./page-referral-tracking.vue?vue&type=style&index=0&id=33c444ef&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports